

export default function IconLabeledItem({ icon, item })  {
   
   const Icon = icon;

   return <div className="flex items-center mb-2">
      {<Icon className="text-gray-600 text-xl" />}
      <div className="text-sm text-gray-600 ml-2 truncate">
         {item}
      </div>
   </div>
}